import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'
import Paparanutama from '@/views/paparanutama/paparanutama.vue'
import Maintemplate from '@/layout/maintemplate/maintemplate.vue'
import Login from '@/views/Login/Login'
import Publicheader from '@/layout/publictemplate/publictemplate'
//import Frontline from '@/views/Frontline/Frontline'
import Daftar from '@/views/Daftar/Daftar'
import Lupatakalaluan from '@/views/Lupatakalaluan/Lupatakalaluan'
import Tetapkanpenyeliaprosesanoperasi from '@/views/tetapkanpenyeliaprosesanoperasi/tetapkanpenyeliaprosesanoperasi'
import Pusingan from '@/views/pusingan/pusingan_new'
import Pamerdatahies from '@/views/Pamerdatahies/pamerdatahies'
import Hiesidresponden from '@/views/Hiesidresponden/hiesidresponden'
import Kadarrespon from '@/views/Kadarrespon/kadarrespon'
import pendapatanpurata from '@/views/pendapatanpurata/pendapatanpurata'
import penengah from '@/views/penengah/penengah'
import kaumxstrata from '@/views/KaumXstrata/kaumxstrata'
import DaerahXstrata from '@/views/DaerahXstrata/daerahxstrata'
import julatHarga from '@/views/julatHarga/julatHarga'
import julatHargaMinMax from '@/views/julatHarga/julatHargaMinMax'
import pivot from '@/views/pivot/pivot'
import validasi from '@/views/Validasi/validasi'
import Pamerdatavisual from '@/views/Pamerdatahies/pamerdatavisual'


//import testpage from '@/views/Testpage/Testpage'
//import testpage1 from '@/views/Testpage/Testpage1'
//import tablefilter from '@/views/tablefilter/tablefilter'
//import form from '@/views/form/form'
import Penggunasistem from '@/views/penggunasistem/penggunasistem'





/////////////BATCH//////////////////
import batch from '@/views/Daftar/batch'

///////////HID///////////////////
import HID from '@/views/Daftar/HID'

/////////////ringkasanIR////////////////
import ringkasanMaklumatIR from '@/views/paparanutama/ringkasanMaklumatIsiRumah'

///////////BP///////////////////
import BP from '@/views/Daftar/BP'

///////////koditem///////////////////
import koditem3 from '@/views/Daftar/koditem3'
import koditem4a from '@/views/Daftar/koditem4a'
import koditem4b from '@/views/Daftar/koditem4b'
import koditem4c from '@/views/Daftar/koditem4c'

///////HK1//////////////////////////////
import hk1 from '@/views/HIS/hk1'
import hk2 from '@/views/HIS/hk2'
import hk3 from '@/views/HIS/hk3'
import hk4 from '@/views/HIS/hk4'
import hk5 from '@/views/HIS/hk5'
import hk6 from '@/views/HIS/hk6'
import hk7 from '@/views/HIS/hk7'
import hk8 from '@/views/HIS/hk8'
import foodwaste from '@/views/HIS/foodwaste'

///////JR2//////////////////////////////
import JR2 from '@/views/JR/JR2'
import JRC from '@/views/JR/JRC'
import JRB from '@/views/JR/JRB'

import JRE1 from '@/views/JR/JRE1'
import JRE2 from '@/views/JR/JRE2'
import JRF3 from '@/views/JR/JRF3'
import JRG from '@/views/JR/JRG'
import JRH from '@/views/JR/JRH'

import PERBELANJAAN from '@/views/JR/PERBELANJAAN'
import JR2Imbangan from '@/views/JR/JR2Imbangan'
import JRBpindahan from '@/views/JR/JRBpindahan'
import IMBANGAN from '@/views/JR/IMBANGAN'
import JRB1off from '@/views/JR/JRB1off'
import JRCPSD from '@/views/JR/JRCPSD'
import JRD from '@/views/JR/JRD'
import ringkasanpendapatanAIR from '@/views/JR/ringkasanpendapatanAIR'


//////////////////blk//////////////////
import BLK3PreCode from '@/views/HES/BLK3PreCode' //first page hes
import blk3 from '@/views/HES/blk3'
import Blok4a from '@/views/HES/Blok4a'
import Blok4b from '@/views/HES/Blok4b'
import Blok4c from '@/views/HES/Blok4c'
import blk7 from '@/views/HES/blk7'
import Blok7Imbangan from '@/views/HES/Blok7Imbangan' 
import PengesahanImbangan from '@/views/HES/PengesahanImbangan' 
import Heshid from '@/views/HES/heshid'
///////////////////////summary/////////////////
import summaryJRB from '@/views/summary/summaryJRB'

import wajaran from '@/views/wajaran/wajaran'






Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/testpage',
  //   name: 'testpage',
  //   component: testpage,
  // },
  {
    path: '/',
    redirect: `/${i18n.locale}/`,
  },
  {
    path: '/:lang',
    component: Publicheader,
    children: [
      // {
      //   path: "Frontline",
      //   name: "Frontline",
      //   component: Frontline
      // },
      {
        path: "daftar",
        name: "Daftar",
        component: Daftar
      },
      {
        path: `/`,
        name: "Logmasuk",
        component: Login
      },
      {
        path: "lupatakalaluan",
        name: "Lupatakalaluan",
        component: Lupatakalaluan
      },
      {
        path: 'dashboard',
        beforeEnter() {
          window.open(
            'https://app.powerbi.com/view?r=eyJrIjoiNWRiNjMyODgtMGY2OS00OTFiLTliNGEtYzY3MmU0M2IxZDZkIiwidCI6IjM3M2U5MGQyLWQ5YTMtNDNiNS04MzJlLWM4ZTk4NDdhNzlmOCIsImMiOjEwfQ%3D%3D',
            '_blank'
          );
        }
      }
      // {
      //   path: '/testpage1',
      //   name: 'testpage1',
      //   component: testpage1
      // }
    ]
  },
  {
    path: '/:lang',
    component: Maintemplate,
    children: [
      {
        path: 'paparanutama',
        name: "Paparanutama",
        component: Paparanutama,
        meta: { secure: true }
      },
      {
        path: 'pusingan',
        name: "Pusingan",
        component: Pusingan,
        meta: { secure: true }
      },
      {
        path: 'tetapkanpenyeliaprosesanoperasi/:url?',
        name: "Tetapkanpenyeliaprosesanoperasi",
        component: Tetapkanpenyeliaprosesanoperasi,
        meta: { secure: true }
      },
      {
        path: 'penggunasistem',
        name: "Penggunasistem",
        component: Penggunasistem,
        meta: { secure: true }
      },
      {
        path: 'ringkasanMaklumatIR',
        name: "ringkasanMaklumatIR",
        component: ringkasanMaklumatIR,
        meta: { secure: true }
      },
      {
        path: 'batch',
        name: "batch",
        component: batch,
        meta: { secure: true }
      },
      {
        path: 'HID',
        name: "HID",
        component: HID,
        meta: { secure: true }
      },

      {
        path: 'BP',
        name: "BP",
        component: BP,
        meta: { secure: true }
      },

      {
        path: 'koditem3',
        name: "koditem3",
        component: koditem3,
        meta: { secure: true }
      },

      {
        path: 'koditem4a',
        name: "koditem4a",
        component: koditem4a,
        meta: { secure: true }
      },

      {
        path: 'koditem4b',
        name: "koditem4b",
        component: koditem4b,
        meta: { secure: true }
      },

      {
        path: 'koditem4c',
        name: "koditem4c",
        component: koditem4c,
        meta: { secure: true }
      },

      {
        path: 'JR2',
        name: "JR2",
        component: JR2,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRC',
        name: "JRC",
        component: JRC,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRB',
        name: "JRB",
        component: JRB,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hk1',
        name: "hk1",
        component: hk1,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hk2',
        name: "hk2",
        component: hk2,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hk3',
        name: "hk3",
        component: hk3,
        // props: true,
        meta: { secure: true }
      },
     {
       path: 'hk4',
       name: "hk4",
       component: hk4,
       // props: true,
       meta: { secure: true }
     },
      {
        path: 'hk5',
        name: "hk5",
        component: hk5,
        //props: true,
        meta: { secure: true }
      },
      {
        path: 'hk6',
        name: "hk6",
        component: hk6,
        //props: true,
        meta: { secure: true }
      },
    {
      path: 'hk7',
      name: "hk7",
      component: hk7,
      // props: true,
      meta: { secure: true }
    },
    {
      path: 'hk8',
      name: "hk8",
      component: hk8,
      // props: true,
      meta: { secure: true }
    },

    {
      path: 'foodwaste',
      name: "foodwaste",
      component: foodwaste,
      // props: true,
      meta: { secure: true }
    },

    {
      path: 'JRBpindahan',
      name: "JRBpindahan",
      component: JRBpindahan,
      // props: true,
      meta: { secure: true }
    },
    {
      path: 'IMBANGAN',
      name: "IMBANGAN",
      component: IMBANGAN,
      // props: true,
      meta: { secure: true }
    },
 	  {
        path: 'JRB1off',
        name: "JRB1off",
        component: JRB1off,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRCPSD',
        name: "JRCPSD",
        component: JRCPSD,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRD',
        name: "JRD",
        component: JRD,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'ringkasanpendapatanAIR',
        name: "ringkasanpendapatanAIR",
        component: ringkasanpendapatanAIR,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'BLK3PreCode/:hid?',
        name: "BLK3PreCode",
        component: BLK3PreCode,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'blk3/:hid?',
        name: "Blk3",
        component: blk3,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok4a/:hid?',
        name: "Blok4a",
        component: Blok4a,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok4b/:hid?',
        name: "Blok4b",
        component: Blok4b,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok4c/:hid?',
        name: "Blok4c",
        component: Blok4c,
        // props: true,
        meta: { secure: true }
      },     
      {
        path: 'blk7/:hid?',
        name: "blk7",
        component: blk7,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'Blok7Imbangan/:hid?',
        name: "Blok7Imbangan",
        component: Blok7Imbangan,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'PengesahanImbangan/:hid?',
        name: "PengesahanImbangan",
        component: PengesahanImbangan,
        // props: true,
        meta: { secure: true }
      },
	    {
        path: 'summaryJRB',
        name: "summaryJRB",
        component: summaryJRB,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRE1',
        name: "JRE1",
        component: JRE1,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRE2',
        name: "JRE2",
        component: JRE2,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRF3',
        name: "JRF3",
        component: JRF3,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRG',
        name: "JRG",
        component: JRG,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JRH',
        name: "JRH",
        component: JRH,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'PERBELANJAAN',
        name: "PERBELANJAAN",
        component: PERBELANJAAN,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'JR2Imbangan',
        name: "JR2Imbangan",
        component: JR2Imbangan,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'pamerdatahies',
        name: "Pamerdatahies",
        component: Pamerdatahies,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'heshid',
        name: "Heshid",
        component: Heshid,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'hiesidresponden',
        name: "Hiesidresponden",
        component: Hiesidresponden,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'kadarrespon',
        name: "Kadarrespon",
        component: Kadarrespon,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'pendapatanpurata',
        name: "pendapatanpurata",
        component: pendapatanpurata,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'penengah',
        name: "penengah",
        component: penengah,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'kaumxstrata',
        name: "kaumxstrata",
        component: kaumxstrata,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'daerahxstrata',
        name: "DaerahXstrata",
        component: DaerahXstrata,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'julatHarga',
        name: "julatHarga",
        component: julatHarga,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'julatHargaMinMax',
        name: "julatHargaMinMax",
        component: julatHargaMinMax,
        // props: true,
        meta: { secure: true }
      },
      {
        path: 'validasi',
        name: "validasi",
        component: validasi,
        props: true,
        meta: { secure: true }
      },
      {
        path: 'wajaran',
        name: "wajaran",
        component: wajaran,
        meta: { secure: true }
      },
      {
        path: 'pivot',
        name: "pivot",
        component: pivot,
        meta: { secure: true }
      },
      {
        path: 'pamerdatavisual',
        name: "pamerdatavisual",
        component: Pamerdatavisual,
        meta: { secure: true }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        beforeEnter() {
          window.open(
            'https://app.powerbi.com/view?r=eyJrIjoiNWRiNjMyODgtMGY2OS00OTFiLTliNGEtYzY3MmU0M2IxZDZkIiwidCI6IjM3M2U5MGQyLWQ5YTMtNDNiNS04MzJlLWM4ZTk4NDdhNzlmOCIsImMiOjEwfQ%3D%3D',
            '_blank'
          );
        },
        meta: { secure: true }
      }
      
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const datapengguna = JSON.parse(window.localStorage.getItem('user'))
  window.scrollTo(0, 0)
  if(to.matched.some(record => record.meta.secure)) {
    //Check token available
    if(!window.localStorage.getItem('access_token')) {
      next({
        path: `${i18n.locale}/`
      })
    } else {
      next()
    }
  } else {
    //Check token not available
    if(window.localStorage.getItem('access_token')){
      if(datapengguna.role === 'RESPONDENT'){
        next({
          path: `${i18n.locale}/ringkasanMaklumatIR`
        })
      } else {
        next({
          path: `${i18n.locale}/paparanutama`
        })
      }
    }
    next()
  }
})

export default router
